import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectLocationsSearchText = createSelector(
  [(store: RootState) => store.supervisorHome.locationSearchText],
  (searchText) => searchText || ""
);
